(function () {
    'use strict';

    /**
     * Service for detecting MIME types from file content
     * This mimics the functionality of PHP's mime_content_type() function
     */
    angular.module('elogbooksDirectives').factory('mimeTypeDetectorService', mimeTypeDetectorService);

    mimeTypeDetectorService.$inject = ['$q', 'mimeTypeMap'];

    function mimeTypeDetectorService($q, mimeTypeMap) {
        // File signatures (magic numbers) for common file types
        const fileSignatures = [
            { type: 'application/pdf', signature: [0x25, 0x50, 0x44, 0x46] }, // %PDF
            { type: 'image/jpeg', signature: [0xFF, 0xD8, 0xFF] }, // JPEG
            { type: 'image/png', signature: [0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A] }, // PNG
            { type: 'image/gif', signature: [0x47, 0x49, 0x46, 0x38] }, // GIF
            { type: 'image/webp', signature: [0x52, 0x49, 0x46, 0x46], offset: 8, subSignature: [0x57, 0x45, 0x42, 0x50] }, // WEBP
            { type: 'image/tiff', signature: [0x49, 0x49, 0x2A, 0x00] }, // TIFF (little endian)
            { type: 'image/tiff', signature: [0x4D, 0x4D, 0x00, 0x2A] }, // TIFF (big endian)
            { type: 'image/bmp', signature: [0x42, 0x4D] }, // BMP
            { type: 'application/zip', signature: [0x50, 0x4B, 0x03, 0x04] }, // ZIP (could be Office documents)
            { type: 'application/rtf', signature: [0x7B, 0x5C, 0x72, 0x74, 0x66] }, // RTF
            { type: 'application/msword', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // DOC (MS Compound Document)
            { type: 'application/vnd.ms-excel', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // XLS (MS Compound Document)
            { type: 'application/vnd.ms-powerpoint', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // PPT (MS Compound Document)
            { type: 'application/vnd.ms-outlook', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // MSG (MS Compound Document)
            { type: 'application/vnd.ms-excel.sheet.binary.macroenabled.12', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // XLSB (MS Compound Document)
            { type: 'application/vnd.ms-excel.sheet.macroenabled.12', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // XLSM (MS Compound Document)
            { type: 'application/vnd.ms-word.document.macroenabled.12', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // DOCM (MS Compound Document)
            { type: 'application/vnd.ms-powerpoint.presentation.macroenabled.12', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // PPTM (MS Compound Document)
            { type: 'application/vnd.visio', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // VSD (MS Compound Document)
            { type: 'application/vnd.ms-project', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // MPP (MS Compound Document)
            { type: 'application/x-mspublisher', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // PUB (MS Compound Document)
            { type: 'application/x-msaccess', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // MDB (MS Compound Document)
            { type: 'application/vnd.ms-office', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // Generic MS Office (MS Compound Document)

            // XML-based formats
            { type: 'application/xml', signature: [0x3C, 0x3F, 0x78, 0x6D, 0x6C] }, // <?xml
            { type: 'text/xml', signature: [0x3C, 0x3F, 0x78, 0x6D, 0x6C] }, // <?xml

            // Executable and binary formats
            { type: 'application/x-msdownload', signature: [0x4D, 0x5A] }, // MZ (EXE, DLL, COM)
            { type: 'application/x-msi', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // MSI (MS Compound Document)
            { type: 'application/x-sqlite3', signature: [0x53, 0x51, 0x4C, 0x69, 0x74, 0x65, 0x20, 0x66, 0x6F, 0x72, 0x6D, 0x61, 0x74] }, // SQLite
            { type: 'application/x-7z-compressed', signature: [0x37, 0x7A, 0xBC, 0xAF, 0x27, 0x1C] }, // 7z
            { type: 'application/x-rar-compressed', signature: [0x52, 0x61, 0x72, 0x21, 0x1A, 0x07] }, // RAR
            { type: 'application/x-tar', signature: [0x75, 0x73, 0x74, 0x61, 0x72] }, // TAR (POSIX)
            { type: 'application/gzip', signature: [0x1F, 0x8B, 0x08] }, // GZIP
            { type: 'application/x-gzip', signature: [0x1F, 0x8B, 0x08] }, // GZIP

            // Image formats
            { type: 'image/heic', signature: [0x00, 0x00, 0x00, 0x18, 0x66, 0x74, 0x79, 0x70, 0x68, 0x65, 0x69, 0x63] }, // HEIC
            { type: 'image/avif', signature: [0x00, 0x00, 0x00, 0x20, 0x66, 0x74, 0x79, 0x70, 0x61, 0x76, 0x69, 0x66] }, // AVIF
            { type: 'image/x-eps', signature: [0x25, 0x21, 0x50, 0x53, 0x2D, 0x41, 0x64, 0x6F, 0x62, 0x65] }, // EPS
            { type: 'application/postscript', signature: [0x25, 0x21, 0x50, 0x53, 0x2D, 0x41, 0x64, 0x6F, 0x62, 0x65] }, // PS
            { type: 'image/vnd.adobe.photoshop', signature: [0x38, 0x42, 0x50, 0x53] }, // PSD
            { type: 'image/svg+xml', signature: [0x3C, 0x73, 0x76, 0x67] }, // SVG
            { type: 'image/x-icon', signature: [0x00, 0x00, 0x01, 0x00] }, // ICO
            { type: 'image/x-pcx', signature: [0x0A, 0x00, 0x01] }, // PCX
            { type: 'image/vnd.ms-modi', signature: [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1] }, // MDI (MS Compound Document)

            // Audio formats
            { type: 'audio/mpeg', signature: [0x49, 0x44, 0x33] }, // MP3 (ID3)
            { type: 'audio/mpeg', signature: [0xFF, 0xFB] }, // MP3 (MPEG frame sync)
            { type: 'audio/x-wav', signature: [0x52, 0x49, 0x46, 0x46], offset: 8, subSignature: [0x57, 0x41, 0x56, 0x45] }, // WAV
            { type: 'audio/aac', signature: [0xFF, 0xF1] }, // AAC ADTS
            { type: 'audio/aac', signature: [0xFF, 0xF9] }, // AAC ADTS
            { type: 'audio/x-aac', signature: [0xFF, 0xF1] }, // AAC ADTS
            { type: 'audio/x-aac', signature: [0xFF, 0xF9] }, // AAC ADTS
            { type: 'audio/flac', signature: [0x66, 0x4C, 0x61, 0x43] }, // FLAC
            { type: 'audio/ogg', signature: [0x4F, 0x67, 0x67, 0x53] }, // OGG
            { type: 'audio/x-m4a', signature: [0x00, 0x00, 0x00, 0x20, 0x66, 0x74, 0x79, 0x70, 0x4D, 0x34, 0x41] }, // M4A

            // Video formats
            { type: 'video/mp4', signature: [0x00, 0x00, 0x00], offset: 4, subSignature: [0x66, 0x74, 0x79, 0x70] }, // MP4
            { type: 'video/x-msvideo', signature: [0x52, 0x49, 0x46, 0x46], offset: 8, subSignature: [0x41, 0x56, 0x49, 0x20] }, // AVI
            { type: 'video/quicktime', signature: [0x00, 0x00, 0x00, 0x14, 0x66, 0x74, 0x79, 0x70, 0x71, 0x74, 0x20, 0x20] }, // MOV
            { type: 'video/x-ms-wmv', signature: [0x30, 0x26, 0xB2, 0x75, 0x8E, 0x66, 0xCF, 0x11, 0xA6, 0xD9, 0x00, 0xAA, 0x00, 0x62, 0xCE, 0x6C] }, // WMV (ASF)
            { type: 'video/x-flv', signature: [0x46, 0x4C, 0x56, 0x01] }, // FLV
            { type: 'video/webm', signature: [0x1A, 0x45, 0xDF, 0xA3] }, // WEBM (EBML)
            { type: 'video/x-matroska', signature: [0x1A, 0x45, 0xDF, 0xA3] }, // MKV (EBML)
            { type: 'video/mpeg', signature: [0x00, 0x00, 0x01, 0xBA] }, // MPEG (PS)
            { type: 'video/mpeg', signature: [0x00, 0x00, 0x01, 0xB3] }, // MPEG (PS)
            { type: 'video/x-m4v', signature: [0x00, 0x00, 0x00, 0x1C, 0x66, 0x74, 0x79, 0x70, 0x6D, 0x70, 0x34, 0x32] }, // M4V
            { type: 'video/3gpp', signature: [0x00, 0x00, 0x00, 0x14, 0x66, 0x74, 0x79, 0x70, 0x33, 0x67] }, // 3GP
            { type: 'video/x-ms-asf', signature: [0x30, 0x26, 0xB2, 0x75, 0x8E, 0x66, 0xCF, 0x11, 0xA6, 0xD9, 0x00, 0xAA, 0x00, 0x62, 0xCE, 0x6C] }, // ASF

            // Text and document formats
            { type: 'text/plain', signature: [] }, // No specific signature, fallback
            { type: 'text/csv', signature: [] }, // No specific signature, fallback
            { type: 'text/html', signature: [0x3C, 0x21, 0x44, 0x4F, 0x43, 0x54, 0x59, 0x50, 0x45] }, // <!DOCTYPE
            { type: 'text/html', signature: [0x3C, 0x68, 0x74, 0x6D, 0x6C] }, // <html
            { type: 'text/css', signature: [0x40, 0x63, 0x68, 0x61, 0x72, 0x73, 0x65, 0x74] }, // @charset
            { type: 'text/calendar', signature: [0x42, 0x45, 0x47, 0x49, 0x4E, 0x3A, 0x56, 0x43, 0x41, 0x4C, 0x45, 0x4E, 0x44, 0x41, 0x52] }, // BEGIN:VCALENDAR
            { type: 'text/x-vcard', signature: [0x42, 0x45, 0x47, 0x49, 0x4E, 0x3A, 0x56, 0x43, 0x41, 0x52, 0x44] }, // BEGIN:VCARD
            { type: 'message/rfc822', signature: [0x46, 0x72, 0x6F, 0x6D, 0x3A] }, // From:
            { type: 'message/rfc822', signature: [0x52, 0x65, 0x74, 0x75, 0x72, 0x6E, 0x2D, 0x50, 0x61, 0x74, 0x68, 0x3A] }, // Return-Path:
            { type: 'application/json', signature: [0x7B] }, // {
            { type: 'application/javascript', signature: [] }, // No specific signature, fallback
            { type: 'application/sql', signature: [0x53, 0x45, 0x4C, 0x45, 0x43, 0x54] }, // SELECT
            { type: 'application/sql', signature: [0x43, 0x52, 0x45, 0x41, 0x54, 0x45] }, // CREATE
            { type: 'application/sql', signature: [0x49, 0x4E, 0x53, 0x45, 0x52, 0x54] }, // INSERT
            { type: 'application/sql', signature: [0x55, 0x50, 0x44, 0x41, 0x54, 0x45] }, // UPDATE
            { type: 'application/sql', signature: [0x44, 0x45, 0x4C, 0x45, 0x54, 0x45] }, // DELETE
            { type: 'application/sql', signature: [0x41, 0x4C, 0x54, 0x45, 0x52] }, // ALTER
        ];

        // officeTypes / ZIP files with specific content
        const officeTypes = {
            'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'odt': 'application/vnd.oasis.opendocument.text',
            'ods': 'application/vnd.oasis.opendocument.spreadsheet',
            'odp': 'application/vnd.oasis.opendocument.presentation',
            'odg': 'application/vnd.oasis.opendocument.graphics',
            'xps': 'application/vnd.ms-xpsdocument',
            'oxps': 'application/oxps',
            'apk': 'application/vnd.android.package-archive',
            'kmz': 'application/vnd.google-earth.kmz'
        };

        // Legacy Office document types that use the MS Compound Document format
        const legacyOfficeTypes = {
            'doc': 'application/msword',
            'xls': 'application/vnd.ms-excel',
            'ppt': 'application/vnd.ms-powerpoint',
            'msg': 'application/vnd.ms-outlook'
        };

        /**
         * Resolve MIME type when multiple types are detected
         * @param {string[]} mimeTypes - Array of possible MIME types
         * @param {string} extension - File extension
         * @param {string} filename - Full filename
         * @returns {string} - Resolved MIME type
         */
        function resolveMultipleMimeTypes(mimeTypes, extension, filename) {
            // First, check if the extension matches any of the legacyOfficeTypes
            if (legacyOfficeTypes[extension]) {
                // If the extension is in legacyOfficeTypes and one of the possible mime types is a MS Compound Document type
                if (mimeTypes.some(type => type === 'application/msword' || type === 'application/vnd.ms-excel' ||
                                       type === 'application/vnd.ms-powerpoint' || type === 'application/vnd.ms-outlook' ||
                                       type === 'application/vnd.ms-office')) {
                    return legacyOfficeTypes[extension];
                }
            }
            // Then, check if the extension matches any of the officeTypes (ZIP-based)
            else if (officeTypes[extension]) {
                // If the extension is in officeTypes and one of the possible mime types is application/zip
                if (mimeTypes.includes('application/zip')) {
                    return officeTypes[extension];
                }
            }
            // If we still have multiple possible types, try to find one that matches the extension
            else {
                const extensionMimeType = getMimeTypeFromExtension(filename);
                if (extensionMimeType && mimeTypes.includes(extensionMimeType)) {
                    return extensionMimeType;
                } else {
                    // If we can't determine the correct type, use the first one
                    return mimeTypes[0];
                }
            }

            // If none of the above conditions matched, return the first mime type
            return mimeTypes[0];
        }

        /**
         * Resolve MIME type when a single type is detected
         * @param {string} mimeType - Detected MIME type
         * @param {string} extension - File extension
         * @returns {string} - Resolved MIME type
         */
        function resolveSingleMimeType(mimeType, extension) {
            // If it's a ZIP file, check if it's an Office document based on extension
            if (mimeType === 'application/zip') {
                if (officeTypes[extension]) {
                    return officeTypes[extension];
                }
            }

            // If it's a MS Compound Document file, check if it's a legacy Office document based on extension
            if (mimeType === 'application/msword' || mimeType === 'application/vnd.ms-excel' ||
                mimeType === 'application/vnd.ms-powerpoint' || mimeType === 'application/vnd.ms-outlook' ||
                mimeType === 'application/vnd.ms-office') {
                if (legacyOfficeTypes[extension]) {
                    return legacyOfficeTypes[extension];
                }
            }

            // If no special handling is needed, return the original mime type
            return mimeType;
        }

        /**
         * Detect MIME type from file content
         * @param {File} file - The file object to analyze
         * @returns {Promise} - Promise that resolves with the detected MIME type
         */
        function detectMimeType(file) {
            const deferred = $q.defer();
            const reader = new FileReader();

            reader.onload = function(e) {
                const result = e.target.result;
                if (!(result instanceof ArrayBuffer)) {
                    // Fallback to extension-based and browser-detected type if reading fails
                    deferred.resolve(getMimeTypeFromExtension(file.name) || file.type);
                    return;
                }

                const arr = new Uint8Array(result);
                let mimeType = detectMimeTypeFromSignature(arr);
                const extension = file.name.split('.').pop().toLowerCase();

                // If mimeType is an array (multiple possible types), try to determine the correct one based on extension
                if (Array.isArray(mimeType)) {
                    mimeType = resolveMultipleMimeTypes(mimeType, extension, file.name);
                }
                // If it's a single mime type
                else {
                    mimeType = resolveSingleMimeType(mimeType, extension);
                }

                // If no specific MIME type is detected, use extension-based detection as fallback
                if (!mimeType || mimeType === 'application/octet-stream') {
                    mimeType = getMimeTypeFromExtension(file.name) || file.type;
                }

                // For text file types - try to match file extension
                if (mimeType === 'text/plain' || (Array.isArray(mimeType) && mimeType.includes('text/plain'))) {
                    const extensionMimeType = getMimeTypeFromExtension(file.name);
                    if (extensionMimeType) {
                        mimeType = extensionMimeType;
                    }
                }

                // If multiple type detected - try to detect the type from extension
                // or return the first detected type
                if (Array.isArray(mimeType)) {
                    mimeType = getMimeTypeFromExtension(file.name) || mimeType[0];
                }

                deferred.resolve(mimeType);
            };

            reader.onerror = function() {
                // Fallback to extension-based and browser-detected type if reading fails
                deferred.resolve(getMimeTypeFromExtension(file.name) || file.type);
            };

            // Read the first 64 bytes of the file (enough for most signatures)
            reader.readAsArrayBuffer(file.slice(0, 64));

            return deferred.promise;
        }

        /**
         * Detect MIME type from file signature (magic numbers)
         * @param {Uint8Array} arr - Array of bytes from the file
         * @returns {string|string[]|null} - Detected MIME type, array of possible MIME types, or null if not detected
         */
        function detectMimeTypeFromSignature(arr) {
            // First, find all matching signatures
            const matches = [];

            for (let i = 0; i < fileSignatures.length; i++) {
                const signature = fileSignatures[i].signature;

                // Skip types with empty signatures (like text/plain)
                if (signature.length === 0) continue;

                let match = true;

                // Check if the file starts with the signature
                for (let j = 0; j < signature.length; j++) {
                    if (arr[j] !== signature[j]) {
                        match = false;
                        break;
                    }
                }

                // For formats with offset and subsignature (like WEBP)
                if (!match && fileSignatures[i].offset && fileSignatures[i].subSignature) {
                    match = true;
                    const offset = fileSignatures[i].offset;
                    const subSignature = fileSignatures[i].subSignature;

                    for (let j = 0; j < subSignature.length; j++) {
                        if (arr[offset + j] !== subSignature[j]) {
                            match = false;
                            break;
                        }
                    }
                }

                if (match) {
                    matches.push(fileSignatures[i].type);
                }
            }

            // If we found matches, return them
            if (matches.length > 0) {
                // If there's only one match, return it as a string
                if (matches.length === 1) {
                    return matches[0];
                }
                // If there are multiple matches, return them as an array
                return matches;
            }

            // Check for text files (ASCII/UTF-8)
            let isText = true;
            for (let i = 0; i < Math.min(arr.length, 32); i++) {
                // Check if byte is outside printable ASCII range and not a common control character
                if ((arr[i] < 9 || (arr[i] > 13 && arr[i] < 32) || arr[i] > 126) && arr[i] !== 0) {
                    isText = false;
                    break;
                }
            }

            if (isText) {
                return 'text/plain';
            }

            return null;
        }

        /**
         * Get MIME type from file extension
         * @param {string} filename - The filename including extension
         * @returns {string|null} - MIME type or null if not found
         */
        function getMimeTypeFromExtension(filename) {
            if (!filename) return null;

            const extension = filename.split('.').pop().toLowerCase();

            if (mimeTypeMap[extension] && mimeTypeMap[extension].length > 0) {
                return mimeTypeMap[extension][0];
            }

            return null;
        }

        // Service API
        return {
            detectMimeType: detectMimeType
        };
    }
})();
